import { PlatformSharedEntities } from './shared-entities.enum';
import { ResourceAuth } from '@control-tower/platform-core';
import { withMetadata } from '@pf/shared-utility';
import { createMap, Mapper } from '@automapper/core';
import { IMappingProfile } from '@pf/shared-common';

export const ResourceAuthSymbol = PlatformSharedEntities.ResourceAuth;

export const withResourceAuthMetadata = () => {
    withMetadata<ResourceAuth>(ResourceAuthSymbol, {
        allAuthorized: Boolean,
        vendors: [String],
        locations: [String],
        carriers: [String],
        customers: [String],
    });
};

/**
 * Self-map for `ResourceAuth`. Registering this forces pojos to deep-map
 * ResourceAuth via the declared metadata — stripping unknown keys like the
 * `$type` discriminator that Newtonsoft.Json emits on SignalR payloads
 * (see `ControlTower.Platform.Events.WebSocketBroadcastService`). Without
 * it, pojos falls back to a reference copy and those unknown keys survive
 * into the CreateBody, producing invalid JSON Patch ops on save.
 */
export const ResourceAuthMetadataMap: IMappingProfile = {
    symbols: {
        entity: ResourceAuthSymbol,
        dto: ResourceAuthSymbol,
        createBody: ResourceAuthSymbol,
        searchParams: ResourceAuthSymbol,
    },
    profile: (mapper: Mapper) => {
        createMap<ResourceAuth, ResourceAuth>(
            mapper,
            ResourceAuthSymbol,
            ResourceAuthSymbol
        );
    },
};
